module.exports = __webpack_public_path__ + "media/application/images/svgs/icon-minus-fd971d7fd4b2636a146d666463194551.svg";